//  Replaces avant-views alert_box section template (note: since there is so much
//  variability in HSBC banners, this likely will not work in every case; work with
//  Lauren to make HSBC banners more consistent rather than make this directive
//  excessively complex just to deal with the few edge cases.)
//
//  Attribute details:
//    banner-type: [required] the 4 bannerTypes are: "info", "warning", "error", "success"
//      for pre-v5 partners, this directive can be used with bannerType set to anything but the 4
//      bannerTypes above.
//    blurb-size: [optional; "small" or "medium"] used in banners that have a `headline--small` or
//      `headline--medium` class on the banner blurb div.
//    subject-size: [optional; "small" or "medium"] used in banners that have a `headline--small` or
//      `headline--medium` class on the banner subject div.
//    icon-href: [optional] the name of the icon used in the subject line if any
//    subject-content: [optional] the subject line of the banner
//
//  Example usage:
//    <amount-banner
//      banner-type="info"
//      blurb-size="medium"
//      subject-content="Some things you should know!"
//      subject-size="medium"
//      icon-href="#icon-solid-exclamation"
//    >
//      Any content here will be transcluded into the amountBanner template. You
//      can use <strong>HTML tags</strong> here.
//    </amount-banner>

const amountBanner = () => {
  return {
    restrict: "E",
    transclude: true,
    template: require("./template.html"),
    scope: {
      bannerType: "@",
      iconHref: "@",
      subjectContent: "@",
      subjectSize: "@",
    },
    link: (scope, element) => {
      scope.isValidBannerType = (type) => {
        const bannerTypes = ["info", "warning", "error", "success"];
        return bannerTypes.indexOf(type) >= 0;
      }

      scope.blurbClasses = () => {
        if (scope.blurbSize) {
          return `banner__blurb headline headline--${scope.blurbSize}`;
        } else if (scope.isValidBannerType(scope.bannerType)) {
          return "banner__blurb";
        }
        return "";
      }

      scope.sectionClasses = () => {
        if (scope.isValidBannerType(scope.bannerType)) {
          return `banner banner--${scope.bannerType}`;
        }
        return "app-form__readonly";
      }

      scope.subjectClasses = () => {
        if (scope.subjectSize) {
          return `banner__subject headline headline--${scope.subjectSize}`;
        } else if (scope.isValidBannerType(scope.bannerType)) {
          return "banner__subject";
        }
        return "";
      }
    },
  };
}

angular
  .module("avant.customer_applications.directives")
  .directive("amountBanner", amountBanner);
